import styled from 'styled-components';
export const TertiaryTitle = styled.h3 `
    font-size: ${(props) => props.theme.fonts.textSizeSmall};
    color: ${(props) => props.theme.colors.textTertiary};
    text-transform: uppercase;
    letter-spacing: 1px;
`;
//# sourceMappingURL=Title.styles.js.map